import { createClient, NhostClientOptions, type NhostClient } from '@nhost/nhost-js';
import { createContext, PropsWithChildren, useContext } from 'react';

const subdomain = import.meta.env?.REACT_APP_NHOST_SUBDOMAIN;
const region = import.meta.env?.REACT_APP_NHOST_REGION;

const authUrl = import.meta.env?.REACT_APP_NHOST_AUTH_URL;
const hasuraUrl = import.meta.env?.REACT_APP_NHOST_HASURA_URL;
const functionsUrl = import.meta.env?.REACT_APP_NHOST_FUNCTIONS_URL;

const nhostClientOptions: NhostClientOptions =
  authUrl && hasuraUrl && functionsUrl
    ? {
        authUrl: `${authUrl}/v1`,
        graphqlUrl: `${hasuraUrl}/v1/graphql`,
        // functionsUrl: `${functionsUrl}/v1`, temporary fix for functions as DNS is not working
        functionsUrl: `https://${subdomain}.functions.${region}.nhost.run/v1`,
        storageUrl: `https://${subdomain}.storage.${region}.nhost.run/v1`,
      }
    : {
        subdomain,
        region,
      };

export const nhost = createClient({
  ...nhostClientOptions,
});

const NhostContext = createContext<NhostClient | null>(null);

export function NhostProvider({ nhost, children }: PropsWithChildren<{ nhost: NhostClient }>) {
  return <NhostContext.Provider value={nhost}>{children}</NhostContext.Provider>;
}

export function useNhostClient() {
  const context = useContext(NhostContext);
  if (!context) {
    throw new Error('useNhostClient must be used within NhostProvider');
  }
  return context;
}
